import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectApi } from '@socialive/common';

export default createAsyncThunk('recordings/updateStream', async ({ id, data }, { getState }) => {
  const api = selectApi(getState());

  return api(`/streams/${id}`, {
    method: 'PATCH',
    data,
  });
});
